import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfiniteTerminologiesResponse, ITerminologies } from "./types";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllTerminologies");

type IResponse = IWithInfinite<IInfiniteTerminologiesResponse>;
type IVariables = ITerminologies;

const getAllInfiniteTerminologies = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(props), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteTerminologies = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteTerminologies({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
